import { useBannerTop } from "@components/common/BannerTop/useBannerTop";
import { Button } from "@kirvanobr/button";
import { CurrencyDollarCircle } from "@untitled-ui/icons-react";
import { ModalContent } from "@kirvanobr/modal";
import { Typography } from "@kirvanobr/typography";
import { isMobile } from "react-device-detect";

export function Buyer() {
  const { becomeSeller } = useBannerTop();

  return (
    <ModalContent>
      {onClose => (
        <>
          <section>
            <div className="w-full text-center">
              <div className="w-full h-[120px] rounded-md bg-[url('/assets/banners/banner-marketplace-modal.png')] bg-cover" />
              <Typography variant="title" size="t4" weight="bold" className="mt-4">
                Marketplace de afiliados
              </Typography>
              <Typography variant="body" size="t4" weight="regular" className="mt-2">
                <b>Crie, venda e lucre:</b> Transforme sua ideia em um produto de sucesso na Kirvano!{" "}
                <b>Que tal se tornar um criador e ter seu próprio produto na vitrine da Kirvano?</b>
              </Typography>
            </div>
          </section>

          <section></section>

          <section className="flex">
            <Button
              color="tertiary"
              size={isMobile ? "sm" : "md"}
              radius="full"
              fullWidth
              className="bg-transparent text-foreground-600"
              onClick={onClose}
            >
              Deixar para depois
            </Button>
            <Button
              color="primary"
              size={isMobile ? "sm" : "md"}
              radius="full"
              fullWidth
              onClick={() => {
                onClose();
                becomeSeller();
              }}
            >
              <CurrencyDollarCircle fontSize={20} />
              Começar a vender
            </Button>
          </section>
        </>
      )}
    </ModalContent>
  );
}
